package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class EventPlayerStatDto(
    val id: String,
    val eventId: String,
    val userId: String,
    val statTypeId: String,
    val value: Int
)

@Serializable
data class EventPlayerStatsResultDto(
    val eventId: String,
    val sportId: String,
    val statTypes: List<SportStatTypeDto>,
    val playerStats: List<EventPlayerStatDto>
)

@Serializable
data class EventPlayerRatingDto(
    val id: String,
    val eventId: String,
    val reviewerId: String,
    val ratedUserId: String,
    val generalRating: String,
    val details: List<EventPlayerRatingDetailDto>,
    val createdAt: String,
    val updatedAt: String,
    // Populated by `POST /rate` only — null on the `GET /ratings` list
    // response. `eventAverageRating` is the event-scope ★ X.X for the
    // rated player AFTER this vote; `playerOverallRating` is the
    // recomputed `sport_profile.overall_rating` (1.0–5.0; × 20 → FIFA
    // 0–100). Lets the client refresh both UI numbers without a
    // follow-up GET.
    val eventAverageRating: String? = null,
    val playerOverallRating: String? = null,
)

@Serializable
data class EventPlayerRatingDetailDto(
    val attributeId: String,
    val value: String
)

@Serializable
data class SetPlayerStatsRequest(
    val stats: List<PlayerStatEntry>
)

@Serializable
data class PlayerStatEntry(
    val statTypeId: String,
    val value: Int
)

@Serializable
data class RatePlayerRequest(
    val generalRating: String,
    val detailedRatings: List<DetailedRatingRequest>? = null
)

@Serializable
data class DetailedRatingRequest(
    val attributeId: String,
    val value: String
)

@Serializable
data class EventTeamStatDto(
    val id: String,
    val eventId: String,
    val eventTeamId: String,
    val statTypeId: String,
    val value: Int
)

@Serializable
data class EventTeamStatsResultDto(
    val eventId: String,
    val sportId: String,
    val statTypes: List<SportStatTypeDto>,
    val teamStats: List<EventTeamStatDto>
)

@Serializable
data class SetTeamStatsRequest(
    val stats: List<PlayerStatEntry>
)

@Serializable
data class ToggleExtendedStatsRequest(
    val enabled: Boolean
)
